import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-scora-video-view',
  templateUrl: './scora-video-view.component.html',
  styleUrls: ['./scora-video-view.component.css']
})
export class ScoraVideoViewComponent implements OnInit {

  @Input() selectedData:any;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-common-module/scora-video-view/scora-video-view.component.ts